import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material';

export const useStyles = makeStyles<Theme>((theme) => ({
  main: {
    height: '100%',
    color: theme.palette.text.primary,
    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.drawerWidth,
    },
  },
  content: {
    padding: theme.spacing(3),
  },
  loadingWrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
